import { render, staticRenderFns } from "./ValueConfirmDialog.vue?vue&type=template&id=63dea171&scoped=true&"
import script from "./ValueConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./ValueConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ValueConfirmDialog.vue?vue&type=style&index=0&id=63dea171&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dea171",
  null
  
)

export default component.exports